module.exports = __webpack_public_path__ + "img/icon-second.999acaf7.png";